/**
 * PC_TG_01
 * Importing the component, API and packages
 */
import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import { getTemplateCategoryDetails, deleteTemplate } from '../../service/PerformanceAPI';
import { useNavigate, useLocation } from 'react-router-dom';
import EvaluationPopUp from '../../components/EvaluationPopUp';
import './Template.css';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Loader from '../../StaticComponent/Loader';
import Popup from '../../components/ConformationPopup/Popup';
import { encryptStorage } from '../../constant';
import { getS3 } from '../../utils/Download';

export default function TemplateData() {
    const navigate = useNavigate();
    let { state } = useLocation();
    /**
     * PC_TG_02
     * State variables are created
     */
    const [template, setTemplate] = useState([]);
    const [category, setCategory] = useState([]);
    const [nodata, setNoData] = useState(false);
    const [goalType, setGoalType] = useState();
    const [templateId, setTemplateId] = useState();
    const [breadCrumbsData, setbreadCrumbsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [categoryClicked, setCategoryClicked] = useState('');
    const [insertToast, setinsertToast] = useState(false);
    const [ToastColor, setToastColor] = useState('');
    const [ToastPara, setToastPara] = useState('');
    const [ToastValue, setToastValue] = useState('');
    const [templateUrls, setTemplateUrls] = useState({});
    /**
     * PC_TG_03
     * useEffect is invoked andthen loadTemplateData function is called
     */
    useEffect(() => {
        if (encryptStorage.getItem('groupid') == 1 || encryptStorage.getItem('groupid') == 2 ) {
            let toastCheck = sessionStorage.getItem('templateToast')
        if (toastCheck == 'inserted' || toastCheck == 'updated') {
            setTimeout(() => {
                if (toastCheck == 'inserted') {
                    setToastPara('Template is Inserted'); setToastValue('Successfully Inserted'); setinsertToast(true); setToastColor('green');
                    setTimeout(() => {
                        setinsertToast(false)
                    }, 2500);
                }
                if (toastCheck == 'updated') {
                    setToastPara('Template is Updated'); setToastValue('Successfully Updated'); setinsertToast(true); setToastColor('green')
                    setTimeout(() => {
                        setinsertToast(false)
                    }, 2500);
                }
                sessionStorage.removeItem('templateToast')
            }, 500);
        }
        loadTemplateData();
        }else {
            navigate('/', { state: { hideNav: false } });
             }
        
    }, []);

    useEffect(() => {
        (async () => {
            const urlPromises = template.map(async eachTemplate => {
                const url = eachTemplate.attachment_url ? await getS3(eachTemplate.attachment_url) : '/Images/Template-3.svg';
                return [eachTemplate.id, url];
            });
            const urls = await Promise.all(urlPromises);
            setTemplateUrls(Object.fromEntries(urls));
        })();
    }, [template]);
    useEffect(() => {
        if (state?.way == 'nav') {
            setbreadCrumbsData([
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: 'Team Member', path: '', isActive: true },
                { title: 'Manage Goal Template', path: '/goaltemplate', isActive: false },
            ])
        }
    }, [state?.way])
    /**
     * PC_TG_04,PC_TG_09,PC_TG_10
     * getTemplateCategoryDetails function is invoked to retrieve the data
     * then response is set in state variable
     */

    const loadTemplateData = async () => {
        let breadcrumbsCreation = state?.way == 'nav' ?
            [
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: 'Team Member', path: '', isActive: true },
                { title: 'Manage Goal Template', path: '/goaltemplate', isActive: false },
            ] :
            [
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: 'Team Member', path: '', isActive: true },
                { title: 'Performance', path: '/performance', isActive: true },
                { title: 'Choose a template', path: '', isActive: false },
            ]
        setbreadCrumbsData(breadcrumbsCreation)
        if (state?.profileBreadcrumbs) {
            let breadcrumbsCreation = state?.profileBreadcrumbs
            breadcrumbsCreation[breadcrumbsCreation.length - 1].isActive = true
            breadcrumbsCreation[breadcrumbsCreation.length - 1].path = `/profilecontainer${state?.redirect}`
            breadcrumbsCreation.push({ title: 'Choose a template', path: '', isActive: false })
            setbreadCrumbsData(breadcrumbsCreation)
        }

        setIsLoading(false);
        if (state) {
            if (state.type) {
                setGoalType(state.type);
            }
        }

        let templateInfo = await getTemplateCategoryDetails();
        if (templateInfo.data.ResponseData.template == 'No data found') {
            setNoData(true);
            setIsLoading(true);
        }
        setTemplate(templateInfo.data.ResponseData.template);
        setCategory(templateInfo.data.ResponseData.category);
        setIsLoading(true);
    };

    /**
     * PC_TG_20
     * @param {*} templateId - passed as parameter for editing particular template
     */
    const templateEditClicked = async (templateId) => {
        navigate(`/goaltemplateform/${templateId}`, {
            state: { ...state, type: goalType },
        });
    };

    /**
     * PC_TG_13,PC_TG_19
     * templateDeleteClicked function is invoked when delete button is clicked
     * deleteTemplate function is called to delete the template
     * loadTemplateData function invoked after successfull response from backend
     */
    const templateDeleteClicked = async () => {
        let obj = {
            templateId: templateId,
        };
        let templateInfo = await deleteTemplate(obj);
        if (templateInfo.data.ResponseData == 'Succcesfully deleted') {
            sideCategoryClick(categoryClicked);
            setToastPara('Template is Deleted');
            setToastValue('Successfully Deleted');
            setinsertToast(true);
            setToastColor('Red');
            setTimeout(() => {
                setinsertToast(false)
            }, 2500);
        }
    };

    /**
     * PC_TG_11
     * @param {*} categoryId when user clicks a category the sideCategoryClick function is called with categoryId as paramter
     * then getTemplateCategory API is called with categoryId 
     */
    const sideCategoryClick = async (categoryId) => {
        if (categoryId == 'All') {
            let templateInfo = await getTemplateCategoryDetails();
            setTemplate(templateInfo.data.ResponseData.template);
            setNoData(false);
            $('menu-id-ALL').addClass('active');
        } else {
            setCategoryClicked(categoryId)
            let templateInfo = await getTemplateCategoryDetails({ category_id: categoryId, id: '' });
            templateInfo.data.ResponseData == 'No data found' ? setNoData(true) : setNoData(false);
            setTemplate(templateInfo.data.ResponseData.template);
            $('menu-id-' + categoryId).removeClass('active');
            $('menu-id-' + categoryId).addClass('active');
        }
    };

    /**
     * PC_TG_12 
     * @param {*} id  - templateId is passed as parameter the using useNavigate user is navigate to goalForm with templateId and goalType
     */
    const templateClicked = (id) => {
        navigate('/goalform', { state: { ...state, type: goalType, templateId: id } });
    };

    return (
        <>
            {insertToast ? (
                <EvaluationPopUp color={ToastColor} Page={'Success Insert'} Heading={ToastValue} Paragraph={ToastPara} />
            ) : null}
            <Popup
                deleteData={() => {
                    templateDeleteClicked();
                }}
            />
            <Loader isLoading={isLoading} />
            <div className="body-bg pt-3">
                <div className="container-fluid">
                    <div className="row justify-content-center mt-5">
                        <div className="col-md-10">
                            <div className='mt-3' style={{ "margin-left": "-12px" }}>
                                <BreadCrumbs data={breadCrumbsData} />
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <p className="tt-bold mb-0">Manage Goal Template</p>
                                {state?.way === 'nav' ?

                                    < div >
                                        <button
                                            onClick={() => {
                                                navigate('/goaltemplateform', { state: { ...state, type: goalType } })
                                            }}
                                            type="button"
                                            className="btn hive-btn-primary"
                                        >
                                            <span>
                                                <img src="/Images/hive-add-icon.svg" className="me-2" />
                                            </span>
                                            Add Goal Template
                                        </button>
                                    </div> : null}
                            </div>
                            <div className="row">
                                <div className="col-md-2 px-0 py-2 goal-template-list-backgrd" style={{ 'max-height': "550px" }}>
                                    <div className="align-items-start">
                                        <div
                                            className="nav flex-column nav-pills"
                                            id="v-pills-tab"
                                            role="tablist"
                                            aria-orientation="vertical"
                                        >
                                            <button
                                                className={`nav-link rounded-0 text-start active sidestyle btn-gradient-sty font-12 semibold-text `}
                                                id="menu-id-ALL"
                                                data-bs-toggle="pill"
                                                data-bs-target="#v-pills-home"
                                                type="button"
                                                role="tab"
                                                aria-controls="v-pills-home"
                                                aria-selected="true"
                                                onClick={() => {
                                                    sideCategoryClick('All');
                                                    setCategoryClicked('All')
                                                }}
                                            >
                                                All
                                            </button>
                                            {category.map((eachCategory) => {
                                                return (
                                                    <button
                                                        className={`nav-link rounded-0 text-start sidestyle btn-gradient-sty font-12 semibold-text `}
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#v-pills-home"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="v-pills-home"
                                                        aria-selected="true"
                                                        onClick={() => {
                                                            sideCategoryClick(eachCategory.id);
                                                        }}
                                                    >
                                                        {eachCategory.category_name}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                        <div className="tab-content" id="v-pills-tabContent">
                                            <div
                                                className="tab-pane fade show active"
                                                id="v-pills-home"
                                                role="tabpanel"
                                                aria-labelledby="v-pills-home-tab"
                                            />
                                            <div
                                                className="tab-pane fade"
                                                id="v-pills-profile"
                                                role="tabpanel"
                                                aria-labelledby="v-pills-profile-tab"
                                            />
                                            <div
                                                className="tab-pane fade"
                                                id="v-pills-messages"
                                                role="tabpanel"
                                                aria-labelledby="v-pills-messages-tab"
                                            />
                                            <div
                                                className="tab-pane fade"
                                                id="v-pills-settings"
                                                role="tabpanel"
                                                aria-labelledby="v-pills-settings-tab"
                                            />
                                            <div
                                                className="tab-pane fade"
                                                id="v-pills-settings"
                                                role="tabpanel"
                                                aria-labelledby="v-pills-settings-tab"
                                            />
                                            <div
                                                className="tab-pane fade"
                                                id="v-pills-settings"
                                                role="tabpanel"
                                                aria-labelledby="v-pills-settings-tab"
                                            />
                                            <div
                                                className="tab-pane fade"
                                                id="v-pills-settings"
                                                role="tabpanel"
                                                aria-labelledby="v-pills-settings-tab"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-10">
                                    <div className="row">
                                        {nodata ? (
                                            <div className="row justify-content-center">
                                                <img src="/Images/nodatafound.png" alt="nodatafound" className="nofeedbackimg-sty" />
                                                <h2 className="tt-bold font-15 text-center margin-negative">No Templates Found</h2>
                                            </div>
                                        ) : (
                                            template?.map((eachTemplate) => {
                                                return (
                                                    <div className="col-md-4 mt-0 mb-3" id={eachTemplate.id}>
                                                        <div className="h-100 border-0 template-border bg-white">
                                                          <img
    src={
        templateUrls[eachTemplate.id] 
        || '/Images/Template-3.svg'
    }
    className="w-100"
    alt="Card-Image"
    style={eachTemplate.attachment_url ? { height: '172px' } : {}}
    onClick={() => {
        { let booleanFlag = state?.way !== 'nav' ? templateClicked(eachTemplate.id) : null }
    }}
/>
                                                            <div style={{ "word-break": "break-word" }} className="p-3">
                                                                <div className="justify-content-between d-flex">
                                                                    <label style={{ "word-break": "break-word" }} className="bold-text font-15 mb-2 align-self-center goal-blackfont">
                                                                        {eachTemplate.name}{' '}
                                                                    </label>
                                                                    {state?.way === 'nav' && encryptStorage.getItem('employeeId') === eachTemplate.created_by ?
                                                                        <div>
                                                                            <button
                                                                                type="button"
                                                                                className="btn p-0 align-top shadow-none"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                            >
                                                                                <img src="/Images/kebab-menu.svg" className="kebab-size" />
                                                                            </button>
                                                                            <ul className="dropdown-menu dropdown-menu-end border-0 shadow-sm">
                                                                                <li>
                                                                                    <a
                                                                                        className="dropdown-item semibold-text font-12 goal-template-kebabitems-color"
                                                                                        onClick={() => { templateEditClicked(eachTemplate.id) }}
                                                                                    >
                                                                                        <span>
                                                                                            <img
                                                                                                className="pe-2"
                                                                                                src="/Images/hive-edit-icon.svg"
                                                                                            />
                                                                                        </span>
                                                                                        Edit
                                                                                    </a>
                                                                                </li>
                                                                                <li>
                                                                                    <a
                                                                                        className="dropdown-item semibold-text font-12 goal-template-kebabitems-color"
                                                                                        onClick={() => {
                                                                                            setTemplateId(eachTemplate.id);
                                                                                        }}
                                                                                        data-bs-toggle="modal"
                                                                                        data-bs-target="#logout"
                                                                                    >
                                                                                        <span>
                                                                                            <img
                                                                                                className="pe-2"
                                                                                                src="/Images/hive-delete-icon.svg"
                                                                                            />
                                                                                        </span>
                                                                                        Delete
                                                                                    </a>
                                                                                </li>
                                                                            </ul>
                                                                        </div> : null}
                                                                </div>
                                                                <p className="medium-text font-13 goal-greyfont">
                                                                    {eachTemplate.description}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
